/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBoxMultiple1 = createReactComponent("outline", "box-multiple-1", "IconBoxMultiple1", [["path", { "d": "M7 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2", "key": "svg-1" }], ["path", { "d": "M14 14v-8l-2 2", "key": "svg-2" }]]);

export { IconBoxMultiple1 as default };
//# sourceMappingURL=IconBoxMultiple1.mjs.map
